import React from "react";

import { BuyerSplitModal } from "components/TransactionSplits/BuyerSplit/index";

import { ModalAdapterProps, ModalTypes } from "constants/navigation";

import { useModalAdapter } from "hooks";
import { ApiModel } from "constants/loading";
import WaitForSync from "components/LoadingSpinner/WaitForSync";

interface ParamsReturns {
  primaryBusinessId: string;
  saleLotId: string;
}

export function BuyerSplitModalAdapter(props: ModalAdapterProps) {
  const [hashParams, ignored, onClose] = useModalAdapter<ParamsReturns>(
    ModalTypes.BuyerSplit,
    props,
  );
  const { primaryBusinessId, saleLotId } = hashParams;

  return (
    <WaitForSync requiredData={[ApiModel.SALE_LOTS, ApiModel.BUSINESSES]}>
      <BuyerSplitModal
        key={JSON.stringify(hashParams)}
        saleLotId={saleLotId}
        primaryBusinessId={primaryBusinessId}
        onClose={onClose}
      />
    </WaitForSync>
  );
}
